import { PriceReadModel, SetPricePayload, SetPriceWithProductPayload } from '@client/api';

import { i18n } from '../../i18n';
import { toMoneyStringOrUndefined } from '../moneyUtils/moneyUtils';
import { isDefinedNumber } from '../numberUtils';
import { isDefinedString } from '../stringUtils';
import { combineStrings } from '../stringUtils/combineStrings/combineStrings';
import { toIntervalString } from '../intervalUtils/intervalUtils';

type Price = PriceReadModel | SetPricePayload | SetPriceWithProductPayload | null;

const isPriceReadModel = (price: any): price is PriceReadModel => price != null && price.product != null;

export const isValidDefinedPriceInterval = (price?: Price): boolean =>
  price?.interval != null && isDefinedNumber(price.interval.count) && isDefinedString(price.interval.type);

export const toPriceString = (price?: Price, placeholder?: string) => {
  const priceString = toMoneyStringOrUndefined(price?.unitAmount, placeholder);

  const unitString = isPriceReadModel(price) ? price?.product?.unit?.label : undefined;

  return combineStrings(` ${i18n.t('per', { ns: 'common' })} `, priceString, unitString);
};

export const toPriceIntervalString = (price?: Price, placeholder?: string) => {
  if (!price?.interval) return placeholder;
  if (!isDefinedNumber(price.interval.count)) return placeholder;
  if (!isDefinedString(price.interval.type)) return placeholder;

  return i18n.t('price.intervalDescription', {
    count: price.interval.count,
    type: price.interval.type,
    ns: 'global',
    defaultValue: undefined,
  });
};

export const toPriceWithIntervalString = (price?: Price, placeholder?: string) => {
  const priceString = toPriceString(price, placeholder);
  const intervalString = toIntervalString(price?.interval);

  return combineStrings(' ', priceString, intervalString);
};

export const toTotalAmountPriceString = (
  quantity: number | undefined,
  price: PriceReadModel | undefined,
  placeholder?: string,
) => {
  if (quantity == null || price == null) return placeholder;

  return toPriceWithIntervalString(
    {
      ...price,
      unitAmount: {
        ...price.unitAmount,
        amount: price.unitAmount.amount * quantity,
      },
    },
    placeholder,
  );
};
